<template>
  <div>
    <div class="home d-flex">
      <video playsinline autoplay muted loop poster="../assets/images/BH4-MAJ-EXT-lowres-1043.jpg" id="bgvid">
        <source src="../assets/video/Bory_Na_Hradzi_video.mp4" type="video/mp4">
      </video>
      <div class="intro-text d-flex align-items-end px-md-5">
        <div>
          <h1>{{ $t('Bory Na Hrádzi') }}</h1>
          <p v-html="$t('Nová zelená a tichšia etapa sa nachádza')"></p>
          <b-button href="../nasa-stvrt" class="d-block d-md-inline-block" squared variant="primary">{{ $t('O bývaní na Boroch') }}</b-button>
          <b-button href="https://konfiguratorbytu.sk/bory-na-hradzi/public/#exterier" target="_blank" class="d-block d-md-inline-block ml-md-3 mt-2 mt-md-0 btn btn-white">{{ $t('Virtuálna prehliadka exteriérov') }}</b-button>
        </div>
      </div>
    </div>

    <section class="district p-md-3 pt-3 pt-md-5">
      <div class="d-flex flex-wrap align-items-start top mb-5">
        <div class="col-md-6 px-md-5">
          <h2 class="mb-4 m-md-0">{{ $t('Mesto tak, ako ho poznáte') }}</h2>
        </div>
        <div class="col-md-6 d-flex justify-content-center">
          <p class="m-0">{{ $t('Bory kombinujú aktívne rodinné bývanie') }}</p>
        </div>
      </div>
      <div id="mapbox">
        <BuildingMap
          stage="bory4"
          map-key="b4"
          background-image="/map/b4.jpg"
          marker-color="#6fbda8"
          :cross-sell-marker="{ label: 'B2', text: $t('Družstevné bývanie') }"
          distinguish-sold-out
        />
      </div>
    </section>

    <section id="tabulka">
      <FlatsTable :stages="['bory4']" :showStageAndDate="false" :show-vr="true" :hide-status="true"></FlatsTable>
    </section>

    <section class="section-3 p-3">
      <div class="">
        <div class="row px-3 mb-3">
          <div class="col-md-7 bg-img">
            <video playsinline autoplay muted loop poster="../assets/images/na_hradzi_1.jpg" id="bgvid">
              <source src="../assets/video/Sequence_01_7.mp4" type="video/mp4">
            </video>
          </div>
          <div class="col-md-5 p-0 px-md-5 py-3">
            <h2 v-html="$t('Buďte pri tom,<br> na čom záleží')"></h2>
            <p class="mb-5" v-html="$t('Nezmeškajte žiadny z pamätných momentov svojich')"></p>
            <b-button href="https://konfiguratorbytu.sk/bory-na-hradzi/public/#exterier" class="d-block d-md-inline-block mb-4" target="_blank" squared variant="primary">{{ $t('Virtuálna prehliadka exteriérov') }}</b-button>
          </div>
        </div>
        <div class="row px-2">
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-1">
              <h3>{{ $t('Cyklochodník pri dome') }}</h3>
              <p>{{$t('Na zdravý životný štýl činky netreba.')}}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-2">
              <h3>{{ $t('Zóna bez áut') }}</h3>
              <p>{{ $t('Aj vo väčšom meste sa dá prežiť krásne detstvo') }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-3">
              <h3>{{$t('Detské ihriská')}}</h3>
              <p>{{ $t('Štvrť plná detských ihrísk sa postará o nové') }}</p>
            </div>
          </div>
        </div>
        <!-- <div class="row px-3 mb-3">
          <div class="col-md-5 p-0 px-md-5 py-3">
            <h2>Domov, ktorý očarí</h2>
            <p>Na pocite domova záleží. Zhmotnite svoje vízie o bývaní a vyberte si z rozšírenej ponuky štandardov. Kvalitné materiály a veľký výber dekorov až v troch úrovniach. Staňte sa súčasťou štvte navrhnutej pre život a vytvorte si bývanie podľa vašich predstáv.</p>
          </div>
          <div class="col-md-7 bg-img-2"></div>
        </div> -->
      </div>
    </section>

    <section class="about-bottom p-md-3 pl-md-5">
      <div class="d-flex flex-wrap">
        <div class="col-md-4 py-4">
          <h2 class="mb-4">{{$t('Domov, ktorý očarí')}}</h2>
          <p class="mb-3">{{ $t('Na pocite domova záleží.') }}</p>
        </div>
        <div class="col-md-8 pb-3 pb-md-0 pr-md-0">
          <div class="right-img bg-img-2"></div>
        </div>
      </div>
    </section>

<!--    <section class="about-bottom p-md-3 pl-md-5">-->
<!--      <div class="d-flex flex-wrap">-->
<!--        <div class="col-md-6 py-4">-->
<!--          <h2 class="mb-4">Domov, ktorý zažiari</h2>-->
<!--          <p class="mb-3">Vďaka širokej ponuke štandardu si každý obyvateľ vyberie podľa svojich predstáv. <br>V snahe zabezpečiť vášmu bývaniu dlhú životnosť sme pre vás vybrali kvalitné materiály dostupné v rôznych farebných prevedeniach.</p>-->
<!--&lt;!&ndash;          <b-button squared variant="primary">Stiahnuť katalóg štandardov</b-button>&ndash;&gt;-->
<!--        </div>-->
<!--        <div class="col-md-6 pb-3 pb-md-0 pr-md-0">-->
<!--          <div class="right-img"></div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->

    <section class="about-bottom-2">
      <div class="d-flex flex-wrap">
        <div class="col-md-6 bg"></div>
        <div class="col-md-6 signature-section">
          <p class="mb-4 font-weight-bolder">{{ $t('Bory Na Hrádzi spája plne vybavené') }}</p>
        </div>
      </div>
    </section>

    <section class="about-bottom bg-dark-blue p-md-3 pl-md-5">
      <div class="d-flex flex-wrap">
        <div class="col-md-4 py-4">
          <h2 class="mb-4">{{ $t('Máte záujem o družstevné bývanie?') }}</h2>
          <p class="mb-3">{{ $t('Predregistrujte sa prostredníctvom formulára') }}</p>
          <b-button @click="scrollTo('contact-form')" class="d-block d-md-inline-block px-5" squared variant="primary">{{ $t('Mám záujem') }}</b-button>
        </div>
        <div class="col-md-8 pb-3 pb-md-0 pr-md-0">
          <div class="right-img bg-img-2"></div>
        </div>
      </div>
    </section>

    <ContactForm selectedStage="druzstevne"></ContactForm>
  </div>
</template>

<script>
import FlatsTable from "@/components/flats/FlatsTable";
import BuildingMap from "@/components/maps/BuildingMap";
import ScrollTo from "@/utils/scrollTo.util";
import ContactForm from "@/components/shared/ContactForm";
import store from "@/store";

export default {
  name: "NaHradzi",
  components: {ContactForm, BuildingMap, FlatsTable},
  mounted () {
    ScrollTo.hash(this,  () => window.scrollTo(0, 0))
  },
  methods: {
    scrollTo(id) {
      const map = document.getElementById(id)
      map.scrollIntoView({behavior: "smooth", block: 'start'})

    },
  },
  computed: {
    locale() {
      return store.state.lang.$locale
    }
  }
}
</script>

<style lang="sass" scoped>
$md: 768px
$large: 1180px

video
  object-fit: cover
  width: 100vw
  height: 100vh
  position: absolute
  top: 0
  left: 0

.about-bottom-2
  .bg
    background: url('../assets/images/na_hradzi_3_2.jpg') center/cover no-repeat
.about-bottom
  padding-bottom: 11px!important

  &.bg-dark-blue
    background: var(--darkBlue)

    .right-img
      background: url(../assets/images/druzstevne/druzstevne-zaujem-bg.jpg) center/cover no-repeat
  .right-img
    background: url(../assets/images/bory3/bory3-domov.jpg) center/cover no-repeat
  .bg-img-2
    background: url("../assets/images/banner-nahradzi.jpg") center/cover no-repeat
    @media (max-width: $md)
      height: 40vh
      background-size: cover

.section-3
  background: var(--grey)
  color: #fff
  text-align: left
  .bg-img
    // background: url("../assets/images/na_hradzi_1.jpg") center/cover no-repeat
    position: relative

    video
      object-fit: cover
      width: 100%
      height: 100%
      position: absolute
      top: 0
      left: 0

      @media (max-width: $md)
        position: relative
  
  h2
    font-size: 55px
    line-height: 60px
    font-weight: 300
    margin-bottom: 20px
    @media (max-width: $md)
      font-size: 28px
      line-height: 40px
      letter-spacing: -1px
      margin-bottom: 15px
  p
    max-width: 320px
    font-weight: 500
    &:last-child
      margin-bottom: 220px
      @media (max-width: $md)
        margin-bottom: 0
  .bg-col
    height: 800px
    @media (max-width: $md)
      height: 60vh
      margin-bottom: 16px
      padding: 30px
    h3
      font-size: 28px
      line-height: 32px
      font-weight: 400
      margin-bottom: 20px
    p
      font-size: 16px
      line-height: 21px
      font-weight: 500
      @media (max-width: $md)
        font-size: 12px
        line-height: 16px
        max-width: 100%
  .bg-col-1
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/na_hradzi_3_1.jpg") center/cover no-repeat
    background-position: left -530px center

    @media (max-width: $md)
      background-position: center
  .bg-col-2
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/na_hradzi_3_2.jpg") bottom/cover no-repeat
    background-position: -160px center
  .bg-col-3
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/na_hradzi_3_3.jpg") center/cover no-repeat
    background-position: -510px center
    @media (max-width: $md)
      background-position: center
  .col-md-4
    padding-left: 8px
    padding-right: 8px
.home
  background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/BH4-MAJ-EXT-lowres-1043.jpg") top/cover no-repeat
  background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/BH4-MAJ-EXT-lowres-1043.jpg") top/cover no-repeat
  position: relative
  
  &:after
    content: ""
    width: 100%
    height: 100%
    position: absolute
    left: 0
    top: 0
    background: linear-gradient(360deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%)

  p
    margin-bottom: 30px
    max-width: 770px
    
  .intro-text
    position: relative
    z-index: 9

  .btn-white
    background: #fff
    color: #001F33
    border-radius: 0
    border-color: #fff
    position: relative
    padding-left: 55px

    &:before
      content: ""
      width: 27px
      height: 16px
      background: url("../assets/icons/360.svg") center/contain no-repeat
      position: absolute
      left: 15px
      top: 50%
      transform: translateY(-50%)

    &:hover
      background: #CFEDFF
      border-color: #CFEDFF

.district
  background: var(--darkBlue)
  img
    width: 100%
.top
  h2
    font-weight: 300
    font-size: 55px
    line-height: 60px
    letter-spacing: -3px
    @media (max-width: $md)
      font-size: 40px
      line-height: 40px
      letter-spacing: -2px
  p
    font-weight: 500
    max-width: 415px
</style>
